export default __webpack_public_path__ + "static/media/ravpy-icon.f9df364c.svg";